<template>
    <b-modal id="client_other" ref="client_other" @hidden="resetModal"
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            <div v-if="mode === 'status'">
                Update Status for<br>
                <div class="text-primary"> {{ client.data.attributes.name }}</div>
            </div>

            <div v-if="mode === 'comment' || edit">
                {{ !edit ? 'Add' : 'Edit' }} comment for<br>
                <div class="text-primary"> {{ client.data.attributes.name }}</div>
            </div>
        </template>

        <div v-if="mode === 'status'" class="d-flex flex-row mb-4">
            <span class="iconsminds-power-2 mr-3 menu-icon-style"/>

            <p class="my-auto">Status lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the client!
            </p>
        </div>

        <div v-if="mode === 'comment'" class="d-flex flex-row mb-4">
            <span class="iconsminds-speach-bubbles mr-3 menu-icon-style"/>

            <p class="my-auto">Comment lorem You can not change the status as INACTIVE if any unit(s) is/are
                occupied.
                Please discharge the client(s) from the unit(s) before INACTIVE the client!
            </p>
        </div>

        <b-form>
            <b-row v-if="mode === 'status'">
                <b-colxx md="12" class="mb-2">
                    <b-form-group label="Type" class="has-float-label">
                        <template v-slot:label>
                            <span>Change Status <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateStatus" v-model="selected.status" :options="status"
                                  :border-danger="'status' in errors">
                            <template slot="no-options">
                                You need to re-refer this client for further action.
                            </template>
                        </v-select>

                        <b-form-invalid-feedback :state="!'status' in errors"
                                                 v-text="'status' in errors ? errors.status[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="12">
                    <b-form-group label="Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-visibility="focus" mode="single"
                            v-model="datepicker.date"
                            @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>

                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Comment" class="has-float-label">
                        <template v-slot:label>
                            <span>Comment <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.comment" rows="6"
                                         :class="{'border-danger': 'comment' in errors}"
                                         @input="'comment' in errors ? delete errors.comment : ''"
                                         placeholder="Comment"/>

                        <b-form-invalid-feedback :state="!('comment' in errors)"
                                                 v-text="'comment' in errors ? errors.comment[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('client_other')" v-text="'Cancel'"/>

            <state-button variant="primary" v-if="!edit && (mode === 'status' || mode === 'comment')"
                          :click="submitClientOther">Submit
            </state-button>

            <state-button variant="primary" v-if="edit" :click="updateClientComment">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";
import moment from "moment";

export default {
    name: "ClientOtherModal",

    components: {
        StateButton,
    },

    props: [
        'client', 'mode', 'edit'
    ],

    data() {
        return {
            selected: {
                status: [],
            },
            datepicker: {
                date: null,
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getClientOtherForm',
            errors: 'getClientErrors',
        }),

        status() {
            let status = [];

            if (this.client.data.attributes.status.toLowerCase() === "referral") {
                status.push(
                    {label: 'Refuse', value: 'Refuse'},
                    {label: 'No-show', value: 'No-show'}
                );
            } else if (this.client.data.attributes.status.toLowerCase() === "admitted" ||
                this.client.data.attributes.status.toLowerCase() === "transferred" ||
                this.client.data.attributes.status.toLowerCase() === "rehoused") {
                status.push(
                    {label: 'Arrested', value: 'Arrested'},
                    {label: 'Deceased', value: 'Deceased'},
                    {label: 'Hospitalized - COVID-19', value: 'Hospitalized - COVID-19'},
                    {label: 'Hospitalized - Other', value: 'Hospitalized - Other'},
                    {label: 'Incarcerated', value: 'Incarcerated'},
                    {label: 'Missing', value: 'Missing'},
                    {label: 'Rehab', value: 'Rehab'},
                );
            } else if (this.client.data.attributes.status.toLowerCase() === "discharged" ||
                this.client.data.attributes.status.toLowerCase() === "refuse" ||
                this.client.data.attributes.status.toLowerCase() === "no-show") {
                status = [];
            } else {
                status.push({label: 'Rehoused', value: 'Rehoused'});
            }

            return status;
        },
    },

    watch: {
        'datepicker.date'(date) {
            if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
            this.form.date = moment(date).format('YYYY-MM-DD');
        },
    },

    methods: {
        submitClientOther() {
            return new Promise((success, fail) => {
                if (this.mode === 'status') this.$store.dispatch('submitClientStatus', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Status updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('client_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
                else if (this.mode === 'comment') this.$store.dispatch('submitClientComment', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'New comment added!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('client_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },

        updateClientComment() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateClientComment', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetModal();

                            this.$notify('success filled', 'Success!', 'Comment Updated!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('client_other');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            });
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        updateStatus(field) {
            if (field) {
                this.form.status = field.value;
            } else {
                this.form.status = '';
            }
            'status' in this.errors ? delete this.errors.status : '';
        },

        resetModal() {
            this.$emit('close');

            this.selected.status = [];
            this.datepicker.date = null;

            this.$store.commit('setClientOtherForm');
        },
    },
}
</script>

<style scoped>

</style>
